/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Wait for jQuery to be loaded
(function() {
  function waitForjQuery(callback) {
    if (typeof jQuery !== 'undefined') {
      callback();
    } else {
      setTimeout(function() { waitForjQuery(callback); }, 50);
    }
  }

  waitForjQuery(function() {
    jQuery(document).ready(function(){
  jQuery(document).on("click",".swatch_color", function(){
  //jQuery(".swatch_color").click(function(){
    jQuery(document).find(".swatch_color").removeClass("swatch_selected");
    jQuery(this).addClass("swatch_selected");
    var imgid = jQuery(this).attr("prodimg");
    var product_url = jQuery(this).attr("data-url");
    var images = jQuery(document).find("#"+imgid).html();
    var pid = jQuery(this).attr("pid");
    var imagewrapper = jQuery(document).find("#product_"+pid+"_image_wrapper").html(images);
    if ( product_url ) {
      jQuery(document).find( "#product_"+pid+"_image_wrapper" ).parents( '.ProductItem__Wrapper' ).find( '.update-url' ).attr( 'href', product_url );
    }
  });

  var bwp_loaded = false;
  var BIS_show = jQuery('<style id="BIS_triggerStyle_show">#BIS_trigger { display: block !important; }</style>');
  var BIS_hide = jQuery('<style id="BIS_triggerStyle_hide">#BIS_trigger { display: none !important; }</style>');

  // Create a MutationObserver instance with a callback function
  var observer = new MutationObserver(function(mutationsList) {
    mutationsList.forEach(function(mutation) {
      // Check if the mutation is a class change
      if (mutation.attributeName === 'class') {
        if ( mutation.target.className !== '' && mutation.target.classList.contains('bwp-widget-loaded') ) {
          jQuery('.ProductForm__AddToCart').attr( 'hidden', 'true' );
          jQuery('#BIS_triggerStyle_show').remove();
          jQuery('head').append(BIS_hide);

        } else {
          if( jQuery('#BIS_trigger').length > 0 ) {
            jQuery('.ProductForm__AddToCart').attr( 'hidden', 'true' );
            jQuery('#BIS_triggerStyle_hide').remove();
            jQuery('head').append(BIS_show);
          } else {
            jQuery('.ProductForm__AddToCart').removeAttr( 'hidden' );
          }
        }

        // You can implement additional logic here, like triggering an event or updating the UI
      }
    });
  });

  // Observer configuration: observe changes to the 'class' attribute
  var observerConfig = { attributes: true, attributeFilter: ['class'] };


  var bwpInterval = setInterval( function () {
    var targetElement = document.getElementById('bwpFrame');
    if ( targetElement ) {
      bwp_loaded = true;
      // Start observing the target element with the specified configuration
      observer.observe(targetElement, observerConfig);
      if ( targetElement.className !== '' && targetElement.classList.contains('bwp-widget-loaded') ) {
        jQuery('.ProductForm__AddToCart').attr( 'hidden', 'true' );
        jQuery('#BIS_triggerStyle_show').remove();
        jQuery('head').append(BIS_hide);
      } else {
        jQuery('#BIS_triggerStyle_hide').remove();
        jQuery('head').append(BIS_show);
      }
      clearInterval( bwpInterval );
    }
  }, 50 );

  function fetch_varient_sku() {
    if( jQuery(".Product__Wrapper [name='id']").length > 0 ) {
      var sku = jQuery(".Product__Wrapper [name='id']").find(":selected").attr('data-sku');
      if (jQuery(".Product__Wrapper .QuantitySelector__CurrentQuantity").length > 0) {
        var qty = jQuery(".Product__Wrapper .QuantitySelector__CurrentQuantity").val();
      } else {
        var qty = 1;
      }

      if( jQuery(".Product__Wrapper .ProductForm__AddToCart").hasClass('invalid_variant') ) {
        sku = '';
        qty = 1;
      }

      if (typeof window.bwp != 'undefined') {
        window.bwp.updateWidget(sku, qty);
      }
    }
  }

  fetch_varient_sku();

  jQuery(document).on("change", ".Product__Wrapper .ProductForm [type='radio'].SizeSwatch__Radio", function () {
    setTimeout(function(){
      fetch_varient_sku();
    }, 50 );
  });

  jQuery(document).on("change", ".Product__Wrapper [name='id']", function () {
    fetch_varient_sku();
  });
  jQuery(document).on("input", ".Product__Wrapper .QuantitySelector__CurrentQuantity", function () {
    fetch_varient_sku();
  });
  jQuery(document).on("click", ".Product__Wrapper .QuantitySelector__Button", function () {
    fetch_varient_sku();
  });
    }); // End jQuery ready
  }); // End waitForjQuery
})();

// Final Sale notation - show/hide per variant
document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant;

  // Toggle visible final sale display blocks
  document.querySelectorAll('div.variant__final_sale[data-variant-id-final-sale]').forEach(function(el) {
    el.style.display = (el.getAttribute('data-variant-id-final-sale') == variant.id) ? 'block' : 'none';
  });

  // Toggle hidden form inputs (set/clear name to include/exclude from cart properties)
  document.querySelectorAll('input.variant__final_sale_field[data-variant-id-final-sale]').forEach(function(el) {
    el.name = (el.getAttribute('data-variant-id-final-sale') == variant.id) ? 'properties[finalsale]' : '';
  });
});

// Custom PDP Message on PLP - ProductCard never fires variant:changed,
// so we listen directly for the swatch radio change event instead.
// Registered on the CAPTURE phase: theme.js's built-in ProductCard swatch
// handler calls event.stopPropagation() during the bubble phase, which would
// otherwise prevent this document-level listener from ever running.
document.addEventListener('change', function(event) {
  var target = event.target;
  if (!target.matches('.product-card__info [type="radio"]')) return;

  var card = target.closest('product-card');
  if (!card) return;

  // data-variant-id is set on standard single-product swatches (option-value.liquid).
  // Combined cross-product swatches use data-product-url instead — skip those.
  var variantId = target.getAttribute('data-variant-id');
  if (!variantId) return;

  var variantMessageShown = false;

  card.querySelectorAll('div.custom-pdp-message[data-variant-id-custom-message]').forEach(function(el) {
    var show = el.getAttribute('data-variant-id-custom-message') == variantId;
    el.style.display = show ? 'block' : 'none';
    if (show) variantMessageShown = true;
  });

  var fallback = card.querySelector('.custom-pdp-message--product-fallback');
  if (fallback) {
    fallback.style.display = variantMessageShown ? 'none' : 'block';
  }
}, true);

// RG-823: PLP variant pricing — update price-list when a color swatch is selected.
// The product-card__variant-prices-json script tag (injected by product-card.liquid)
// holds pre-formatted prices for every variant so no runtime money formatting is needed.

// Render price HTML into a price-list element given a price-data object.
// vd must have: on_sale, price, compare_at_price, discount
// cls must have: regular, on_sale, compare_at
function rg823RenderPrice(priceList, vd, cls) {
  var html = '';
  if (vd.on_sale) {
    html += '<compare-at-price class="' + cls.compare_at + '">';
    html += '<span class="sr-only">Regular price</span>';
    html += vd.compare_at_price;
    html += '</compare-at-price>';
    html += '<sale-price class="' + cls.on_sale + '">';
    html += '<span class="sr-only">Sale price</span>';
    html += vd.price;
    html += '</sale-price>';
    if (vd.discount > 0) {
      html += '<span class="price-discount"><span>(' + vd.discount + '% OFF)</span></span>';
    }
  } else {
    html += '<sale-price class="' + cls.regular + '">';
    html += '<span class="sr-only">Sale price</span>';
    html += vd.price;
    html += '</sale-price>';
  }
  priceList.innerHTML = html;
}

function rg823UpdateCardPrice(card, variantId) {
  var jsonEl = card.querySelector('.product-card__variant-prices-json');
  if (!jsonEl) return;
  var data;
  try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
  var vd = data.variants && data.variants[variantId];
  if (!vd) return;
  var priceList = card.querySelector('price-list');
  if (!priceList) return;
  rg823RenderPrice(priceList, vd, data.classes);
}

// On swatch click — update price for the newly selected swatch.
// Handles both single-product swatches (data-variant-id) and
// combined cross-product swatches (radio value = product ID).
// Registered on the CAPTURE phase — see note above on the PDP-message
// listener: theme.js's ProductCard swatch handler stops bubble-phase
// propagation on this same event, so a bubble-phase listener here would
// never run. Capture-phase listeners on document fire before the event
// ever reaches the target, so they run regardless of that stopPropagation().
document.addEventListener('change', function(event) {
  var target = event.target;
  if (!target.matches('.product-card__info [type="radio"]')) return;

  var card = target.closest('product-card');
  if (!card) return;

  var jsonEl = card.querySelector('.product-card__variant-prices-json');
  if (!jsonEl) return;
  var data;
  try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
  var priceList = card.querySelector('price-list');
  if (!priceList) return;

  var variantId = target.getAttribute('data-variant-id');
  if (variantId) {
    var vd = data.variants && data.variants[variantId];
    if (vd) rg823RenderPrice(priceList, vd, data.classes);
    return;
  }

  // Combined cross-product swatch — radio value is the linked product ID.
  var prodId = target.value;
  if (!prodId) return;
  var cp = data.combined_products && data.combined_products[prodId];
  if (!cp) return;
  rg823RenderPrice(priceList, cp, data.classes);
}, true);

// On page load — correct initial prices for all cards.
// price-list.liquid may render a different variant/product price than the pre-checked swatch.
function rg823InitCardPrices() {
  document.querySelectorAll('product-card').forEach(function(card) {
    var checked = card.querySelector('.product-card__info [type="radio"]:checked');
    if (!checked) return;

    var jsonEl = card.querySelector('.product-card__variant-prices-json');
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var priceList = card.querySelector('price-list');
    if (!priceList) return;

    var variantId = checked.getAttribute('data-variant-id');
    if (variantId) {
      var vd = data.variants && data.variants[variantId];
      if (vd) rg823RenderPrice(priceList, vd, data.classes);
      return;
    }

    // Combined swatch — radio value is the linked product ID.
    var prodId = checked.value;
    if (!prodId) return;
    var cp = data.combined_products && data.combined_products[prodId];
    if (!cp) return;
    rg823RenderPrice(priceList, cp, data.classes);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', rg823InitCardPrices);
} else {
  rg823InitCardPrices();
}

// Custom PDP Message - show variant-level message, fall back to product-level (PDP)
document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant;
  var variantMessageShown = false;

  // Scope to the product card (PLP) or the whole document (PDP)
  var scope = event.target.closest('product-card') || document;

  // Show/hide variant-specific message divs
  scope.querySelectorAll('div.custom-pdp-message[data-variant-id-custom-message]').forEach(function(el) {
    var show = el.getAttribute('data-variant-id-custom-message') == variant.id;
    el.style.display = show ? 'block' : 'none';
    if (show) variantMessageShown = true;
  });

  // Show product-level fallback only when selected variant has no custom message
  var fallback = scope.querySelector('.custom-pdp-message--product-fallback');
  if (fallback) {
    fallback.style.display = variantMessageShown ? 'none' : 'block';
  }
});

// Load More Products functionality
// NOTE: Shopify hard-limits paginate to 250 products per page.
// When all DOM products are shown, we fetch more via Sections Rendering API (?sections=).
(function() {
  var isLoadingAjax = false;

  /**
   * Attach a fresh IntersectionObserver to product-card[reveal-on-scroll="true"]
   * elements inside the given wrappers.
   *
   * Why: ProductList.connectedCallback() sets up one inView listener that fires
   * once when the list enters the viewport. It never re-fires for programmatically
   * appended cards, so those stay at opacity:0 forever.
   *
   * This function replicates the same opacity/transform animation the theme uses
   * (see ProductList.reveal() in theme.js) but scoped only to the new cards.
   * The observer is attached while the cards are still display:none (hidden-product);
   * when revealBatch() removes that class the browser recalculates intersection and
   * fires the callback for cards that are already in the viewport, or fires later
   * as the user scrolls each card into view.
   */
  function setupRevealObserver(productWrappers) {
    var observer = new IntersectionObserver(function(entries, obs) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var card = entry.target;
        // Animate matching the theme's ProductList.reveal() keyframes
        card.animate(
          [
            { opacity: 0, transform: 'translateY(20px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ],
          { duration: 200, easing: 'ease-in-out', fill: 'forwards' }
        );
        // Remove the attribute so the theme's own CSS opacity:0 rule stops applying
        card.removeAttribute('reveal-on-scroll');
        obs.unobserve(card);
      });
    }, { threshold: 0.05 });

    productWrappers.forEach(function(wrapper) {
      wrapper.querySelectorAll('product-card[reveal-on-scroll="true"]').forEach(function(card) {
        observer.observe(card);
      });
    });
  }

 function revealBatch(button, wrapper) {
  var hiddenCards = Array.from(
    document.querySelectorAll('.product-card-wrapper.hidden-product')
  );

  if (!hiddenCards.length) return;

  // Cards (products and ads alike) carry data-batch from Liquid — reveal every
  // card in the next batch as a unit, rather than slicing a raw hidden-count,
  // so a repeating ad surfaces exactly once per batch instead of drifting.
  var nextBatch = hiddenCards.reduce(function(min, card) {
    var batch = parseInt(card.dataset.batch, 10);
    return Number.isNaN(batch) ? min : Math.min(min, batch);
  }, Infinity);

  if (!Number.isFinite(nextBatch)) return;

  hiddenCards
    .filter(function(card) {
      return parseInt(card.dataset.batch, 10) === nextBatch;
    })
    .forEach(function(card) {
      card.classList.remove('hidden-product');
    });

  // Determine columns from layout
  var columns = window.innerWidth < 700 ? 2 : 3;

  // If the newly revealed batch leaves an incomplete last row, pull extra
  // PRODUCT cards (never ads) from the following batch to complete it.
  // Count every visible grid cell — products AND ads — since an ad occupies
  // a cell in the layout just like a product does.
  var totalVisible = document.querySelectorAll(
    '.product-card-wrapper:not(.hidden-product)'
  ).length;
  var remainder = totalVisible % columns;

  if (remainder !== 0) {
    var extraNeeded = columns - remainder;
    var stillHiddenProducts = Array.from(
      document.querySelectorAll('.product-card-wrapper.hidden-product:not(.product-card-wrapper--ad)')
    );

    for (var i = 0; i < extraNeeded && i < stillHiddenProducts.length; i++) {
      stillHiddenProducts[i].classList.remove('hidden-product');
    }
  }

  updateCount();
  checkIfAllShown(button, wrapper);

  if (typeof window.lazySizes !== 'undefined') {
    window.lazySizes.autoSizer.checkElems();
  }
}

  function updateCount() {
    var countText = document.querySelector('.current-product-count');
    if (countText) {
      var visible = document.querySelectorAll('.product-card-wrapper:not(.hidden-product):not(.product-card-wrapper--ad)').length;
      countText.textContent = visible;
    }
  }

  function checkIfAllShown(button, wrapper) {
    var totalProducts = parseInt(wrapper.getAttribute('data-total-products')) || 0;
    var domTotal = document.querySelectorAll('.product-card-wrapper:not(.product-card-wrapper--ad)').length;
    var remainingHidden = document.querySelectorAll('.product-card-wrapper.hidden-product:not(.product-card-wrapper--ad)').length;

    if (remainingHidden === 0) {
      if (domTotal >= totalProducts) {
        // All products from all pages are now visible — hide the button
        wrapper.classList.add('hidden');
      } else {
        // DOM products exhausted but more exist on the server — fetch next AJAX page
        fetchNextPage(button, wrapper);
      }
    }
  }

  /*
   * Auto-add a configured gift variant when cart value reaches the configured threshold.
   */
  (function() {
   
    var settings = window.themeVariables && window.themeVariables.settings;
    if (!settings) {
      return;
    }

    var giftEnabled = settings.giftEnable === true || settings.giftEnable === 'true';
    var giftVariantId = parseInt(settings.giftVariantId, 10);
    var giftMinValue = parseInt(settings.giftMinValue, 10);
    var giftExcludeProductType = (settings.giftExcludeProductType || '').trim().toLowerCase();
    var isUpdatingGift = false;
    var pendingGiftUpdate = false;

    if (!giftEnabled || Number.isNaN(giftVariantId) || giftMinValue <= 0) {
      return;
    }

    function showGwpStatus(message) {
      var bar = document.getElementById('gwp-status-bar');
      if (!bar) return;
      bar.innerHTML = '<span class="gwp-status-bar__spinner"></span><span>' + message + '</span>';
      bar.style.display = 'flex';
      // Trigger transition on next frame
      requestAnimationFrame(function() { bar.classList.add('is-visible'); });
    }

    function hideGwpStatus() {
      var bar = document.getElementById('gwp-status-bar');
      if (!bar) return;
      bar.classList.remove('is-visible');
      // Hide after fade-out transition (200ms)
      setTimeout(function() {
        if (!bar.classList.contains('is-visible')) {
          bar.style.display = 'none';
          bar.innerHTML = '';
        }
      }, 250);
    }

    function dispatchCartRefresh() {
      if (window.themeVariables && window.themeVariables.settings.pageType === 'cart') {
        window.location.reload();
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    }

    function fetchCart() {
      return fetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          'Accept': 'application/json'
        }
      }).then(function(response) {
        if (!response.ok) {
          throw new Error('Unable to fetch cart');
        }
        return response.json();
      });
    }

    function addGiftToCart() {
     
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: giftVariantId,
          quantity: 1,
          properties: { '_gwp': 'true', 'Gift': 'Complimentary Gift' }
        })
      }).then(function(response) {
        if (!response.ok) {
          return response.json().then(function(errorData) {
            throw new Error(errorData.description || 'Unable to add gift to cart');
          });
        }
        return response.json();
      });
    }

    function removeGiftFromCart(itemKey) {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0
        })
      }).then(function(response) {
        if (!response.ok) {
          throw new Error('Unable to remove gift from cart');
        }
        return response.json();
      });
    }

    function getGiftLineItem(cart) {
      // Prefer the auto-added free gift item (identified by the _gwp property)
      return cart.items.find(function(item) {
        return item.variant_id === giftVariantId &&
          item.properties && item.properties['_gwp'] === 'true';
      }) || cart.items.find(function(item) {
        return item.variant_id === giftVariantId;
      });
    }

    function getCartValueExcludingGift(cart) {
      return cart.items.reduce(function(total, item) {
        var isGwp = item.variant_id === giftVariantId;
        // Exclude native Shopify gift cards (gift_card: true) and any product
        // whose type matches the configured exclusion (e.g. custom gift card products
        // where Shopify returns gift_card: false).
        var isGiftCard = item.gift_card === true ||
          (giftExcludeProductType !== '' &&
            (item.product_type || '').trim().toLowerCase() === giftExcludeProductType);
        console.log('[GWP-DEBUG] item:', item.title, '| product_type:', item.product_type, '| gift_card:', item.gift_card, '| line_price:', item.line_price, '| isGwp:', isGwp, '| isGiftCard:', isGiftCard);
        if (isGwp || isGiftCard) {
          return total;
        }
        return total + (item.line_price || 0);
      }, 0);
    }

    function updateGift(preloadedCart) {
      if (isUpdatingGift) {
        // Queue one follow-up run so a call that arrives mid-update is never silently dropped
        pendingGiftUpdate = true;
        return Promise.resolve();
      }
      isUpdatingGift = true;
      pendingGiftUpdate = false;

      // Use cart data supplied by the cart:change event when available — this eliminates
      // one network round trip and is safe because cart:change fires after the mutation
      // is fully applied. Fall back to a fresh /cart.js fetch for other callers.
      var cartPromise = preloadedCart ? Promise.resolve(preloadedCart) : fetchCart();
      return cartPromise.then(function(cart) {
        var cartValue = getCartValueExcludingGift(cart);
        var giftItem = getGiftLineItem(cart);
        var thresholdReached = cartValue >= giftMinValue;

        if (thresholdReached && !giftItem) {
          showGwpStatus('Adding your complimentary gift…');
          return addGiftToCart().then(function() {
            dispatchCartRefresh();
          });
        }

        if (!thresholdReached && giftItem) {
          console.log('[GWP-DEBUG] → Removing GWP from cart, key:', giftItem.key);
          showGwpStatus('Removing complimentary gift…');
          return removeGiftFromCart(giftItem.key).then(function() {
            dispatchCartRefresh();
          });
        }

        if (thresholdReached && giftItem && giftItem.quantity > 1) {
          return fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: giftItem.key,
              quantity: 1
            })
          }).then(function(response) {
            if (!response.ok) {
              throw new Error('Unable to update gift quantity');
            }
            return response.json();
          }).then(function() {
            dispatchCartRefresh();
          });
        }

        return Promise.resolve();
      }).catch(function(error) {
        console.error('Auto gift cart update failed:', error);
      }).finally(function() {
        hideGwpStatus();
        isUpdatingGift = false;
        if (pendingGiftUpdate) {
          pendingGiftUpdate = false;
          setTimeout(updateGift, 50);
        }
      });
    }

    function onCartChange(event) {
      // Pass the cart from the event detail when available (cart:change provides it).
      // This lets updateGift skip the /cart.js fetch, cutting the perceived lag in half.
      var preloadedCart = event && event.detail && event.detail.cart;
      updateGift(preloadedCart);
    }

    // cart:change fires after every cart mutation (add, remove, quantity change).
    document.addEventListener('cart:change', onCartChange);

    // cart:refresh is fired by the theme on page-show (back/forward cache) and on error paths
    document.addEventListener('cart:refresh', onCartChange);
    document.documentElement.addEventListener('cart:refresh', onCartChange);

    // Run once on load to handle carts that already exceed the threshold
    document.addEventListener('DOMContentLoaded', onCartChange);
    setTimeout(onCartChange, 1000);
  })();

  function fetchNextPage(button, wrapper) {
    if (isLoadingAjax) return;

    if (window.fetchAllPromise) {
      button.textContent = 'Loading...';
      button.disabled = true;
      window.fetchAllPromise.then(function() {
        button.textContent = 'Discover More';
        button.disabled = false;
        if (document.querySelectorAll('.product-card-wrapper.hidden-product').length) {
          revealBatch(button, wrapper);
        } else {
          checkIfAllShown(button, wrapper);
        }
      });
      return;
    }

    isLoadingAjax = true;

    var currentAjaxPage = parseInt(wrapper.getAttribute('data-ajax-page')) || 1;
    var nextPage = currentAjaxPage + 1;
    var collectionUrl = wrapper.getAttribute('data-collection-url');
    var sectionId = wrapper.getAttribute('data-section-id');

    // Preserve active filter/sort params from the current URL.
    // e.g. ?filter.p.custom.pattern_solid=Pattern&sort_by=price-asc
    // We strip any existing "page" param and inject the correct one.
    var currentParams = new URLSearchParams(window.location.search);
    currentParams.delete('page');
    currentParams.set('page', nextPage);
    currentParams.set('sections', sectionId);

    var fetchUrl = collectionUrl + '?' + currentParams.toString();

    // Set button loading state
    button.textContent = 'Loading...';
    button.disabled = true;

    fetch(fetchUrl)
      .then(function(response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function(data) {
        var sectionHtml = data[sectionId];
        if (!sectionHtml) {
          // Fallback: try first key returned (some themes prefix the section id)
          sectionHtml = data[Object.keys(data)[0]];
        }

        if (!sectionHtml) {
          throw new Error('No section HTML found in response');
        }

        var parser = new DOMParser();
        var doc = parser.parseFromString(sectionHtml, 'text/html');
        var newProducts = doc.querySelectorAll('.product-card-wrapper');

        if (newProducts.length === 0) {
          // Nothing came back — past the last page
          wrapper.classList.add('hidden');
          isLoadingAjax = false;
          return;
        }

        var productList = document.querySelector('product-list');
        if (!productList) {
          productList = document.querySelector('.product-list');
        }

        if (!productList) {
          wrapper.classList.add('hidden');
          isLoadingAjax = false;
          return;
        }

        var existingHandles = new Set(
          Array.from(productList.querySelectorAll('.product-card-wrapper[data-product-handle]'), function(card) {
            return card.getAttribute('data-product-handle');
          })
        );
        var maxBatch = 1;
        productList.querySelectorAll('.product-card-wrapper').forEach(function(card) {
          var batch = parseInt(card.getAttribute('data-batch'), 10);
          if (!Number.isNaN(batch) && batch > maxBatch) maxBatch = batch;
        });
        var perPage = parseInt(wrapper.getAttribute('data-products-per-page'), 10) || 48;
        var newProductWrappers = [];
        var newCount = 0;

        window.isCollectionReordering = true;

        newProducts.forEach(function(product) {
          if (product.classList.contains('product-card-wrapper--ad')) {
            return;
          }
          var handle = product.getAttribute('data-product-handle');
          if (handle && existingHandles.has(handle)) {
            return;
          }
          if (handle) {
            existingHandles.add(handle);
          }
          newCount += 1;
          product.setAttribute('data-batch', String(maxBatch + Math.floor((newCount - 1) / perPage) + 1));
          // Keep reveal-on-scroll intact — a fresh IntersectionObserver
          // (set up below) will fire the animation once display:none is lifted.
          product.classList.add('hidden-product');
          productList.appendChild(product);
          newProductWrappers.push(product);
        });

        requestAnimationFrame(function() {
          window.isCollectionReordering = false;
        });

        if (newProductWrappers.length === 0) {
          wrapper.classList.add('hidden');
          isLoadingAjax = false;
          return;
        }

        if (typeof window.reassignCollectionBatches === 'function') {
          window.reassignCollectionBatches();
        }

        // Wire up scroll-reveal for the newly appended cards.
        // We MUST do this after appendChild so the elements are in the document;
        // the observer will fire once revealBatch removes hidden-product (display:none).
        setupRevealObserver(newProductWrappers);

        // Advance the ajax-page counter
        wrapper.setAttribute('data-ajax-page', nextPage);
        isLoadingAjax = false;

        // Restore button then reveal the next batch
        button.textContent = 'Discover More';
        button.disabled = false;

        revealBatch(button, wrapper);
      })
      .catch(function(err) {
        console.error('[LoadMore] AJAX fetch failed:', err);
        isLoadingAjax = false;
        button.textContent = 'Discover More';
        button.disabled = false;
      });
  }

  function initLoadMore() {
    var loadMoreButton = document.querySelector('.load-more-button');
    var loadMoreWrapper = document.querySelector('.load-more-wrapper');

    if (!loadMoreButton || !loadMoreWrapper) return;
    if (loadMoreWrapper.dataset.listenerAttached === 'true') return;

    loadMoreWrapper.dataset.listenerAttached = 'true';

    // Clone to remove any stale event listeners that may be on the element
    var newButton = loadMoreButton.cloneNode(true);
    loadMoreButton.parentNode.replaceChild(newButton, loadMoreButton);

    newButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (isLoadingAjax) return;

      var wrapper = this.closest('.load-more-wrapper');
      if (!wrapper) return;

      var hiddenProducts = document.querySelectorAll('.product-card-wrapper.hidden-product');
      if (hiddenProducts.length > 0) {
        revealBatch(this, wrapper);
      } else {
        checkIfAllShown(this, wrapper);
      }
    });

  }

  /**
   * Watch the collection section for DOM changes caused by AJAX facet updates.
   * When the Prestige theme re-renders the collection (update_on_change facets,
   * sort change, etc.) it replaces the inner HTML, creating a brand-new
   * .load-more-button without our click listener. The MutationObserver detects
   * this and calls initLoadMore() to re-attach.
   */
  function watchForFacetUpdates() {
    var collectionSection = document.querySelector('.shopify-section--main-collection');
    if (!collectionSection) {
      collectionSection = document.querySelector('.collection');
    }
    if (!collectionSection) return;

    var observer = new MutationObserver(function(mutations) {
      var needsReinit = false;
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          // A .load-more-wrapper or .load-more-button was added — re-init
          if (
            node.classList.contains('load-more-wrapper') ||
            node.classList.contains('load-more-button') ||
            node.querySelector && (
              node.querySelector('.load-more-wrapper') ||
              node.querySelector('.load-more-button')
            )
          ) {
            needsReinit = true;
          }
        });
      });

      if (needsReinit) {
        // Small delay to let the full section HTML settle after a facet update
        setTimeout(initLoadMore, 50);
      }
    });

    observer.observe(collectionSection, { childList: true, subtree: true });
  }

  // Run at DOMContentLoaded and with short retries for late-rendered content
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initLoadMore();
      watchForFacetUpdates();
    });
  } else {
    initLoadMore();
    watchForFacetUpdates();
  }

  setTimeout(initLoadMore, 800);
  setTimeout(initLoadMore, 2000);
})();



function updateCartCountVisibility(cartCountContainer, cartCountElement, fallbackCount) {
  if (!cartCountContainer) {
    return;
  }

  var elementCount = cartCountElement ? Number(cartCountElement.textContent && cartCountElement.textContent.trim()) : NaN;
  var effectiveCount = Number.isFinite(elementCount) ? elementCount : fallbackCount;

  if (typeof effectiveCount !== 'number' || Number.isNaN(effectiveCount)) {
    return;
  }

  cartCountContainer.style.display = effectiveCount > 0 ? '' : 'none';
}

function watchCartCountElement(cartCountContainer, cartCountElement) {
  if (!cartCountContainer || !cartCountElement || cartCountElement.__cartCountObserverAttached) {
    return;
  }

  var observer = new MutationObserver(function() {
    updateCartCountVisibility(cartCountContainer, cartCountElement, NaN);
  });

  observer.observe(cartCountElement, { childList: true, subtree: true, characterData: true });
  cartCountElement.__cartCountObserverAttached = true;
}

document.addEventListener('cart:change', function(event) {
  console.log('cart:change', event);
  var itemCount = event?.detail?.cart?.item_count;
  var cartCountContainer = document.querySelector('.header__cart-count');
  var cartCountElement = cartCountContainer ? cartCountContainer.querySelector('cart-count') : null;

  if (!cartCountContainer || typeof itemCount !== 'number') {
    return;
  }

  if (cartCountElement) {
    cartCountElement.textContent = String(itemCount);
  }

  watchCartCountElement(cartCountContainer, cartCountElement);
  updateCartCountVisibility(cartCountContainer, cartCountElement, itemCount);
});

function hasActiveCollectionFilters() {
  return [...new URLSearchParams(window.location.search).keys()]
    .some(function(key) { return key.startsWith('filter.'); });
}

window.reassignCollectionBatches = function reassignCollectionBatches() {
  var list = document.querySelector('.product-list');
  var loadMore = document.querySelector('.load-more-wrapper');
  var perPage = parseInt(
    (list && list.dataset.batchSize) ||
      (loadMore && loadMore.getAttribute('data-products-per-page')),
    10
  ) || 48;

  if (!list) return;

  var productCount = 0;
  Array.from(list.children).forEach(function(card) {
    if (!card.classList.contains('product-card-wrapper')) return;
    if (card.classList.contains('product-card-wrapper--ad')) {
      var slot = parseInt(card.getAttribute('data-ad-slot'), 10) || 0;
      var batch = (slot === perPage + 1 && productCount > 0)
        ? Math.floor((productCount - 1) / perPage) + 1
        : Math.floor(productCount / perPage) + 1;
      card.setAttribute('data-batch', String(batch));
      return;
    }
    productCount += 1;
    card.setAttribute('data-batch', String(Math.floor((productCount - 1) / perPage) + 1));
  });
};

window.fetchAllCompleted = false;
window.fetchAllPromise = null;

function collectPageProducts(html, existingHandles) {
  if (!html) return [];
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const nodes = doc.querySelectorAll('.product-card-wrapper');
  const fresh = [];

  nodes.forEach(function(product) {
    if (product.classList.contains('product-card-wrapper--ad')) {
      return;
    }
    const handle = product.getAttribute('data-product-handle');
    if (handle && existingHandles.has(handle)) {
      return;
    }
    if (handle) {
      existingHandles.add(handle);
    }
    product.classList.add('hidden-product');
    fresh.push(product);
  });

  return fresh;
}

function fetchCollectionPage(collectionUrl, sectionId, page) {
  const params = new URLSearchParams(window.location.search);
  params.delete('page');
  params.set('page', String(page));
  params.set('sections', sectionId);

  return fetch(collectionUrl + '?' + params.toString(), { priority: 'low' }).then(function(response) {
    if (!response.ok) {
      throw new Error('HTTP ' + response.status);
    }
    return response.json();
  }).then(function(data) {
    return data[sectionId] || data[Object.keys(data)[0]] || '';
  });
}

async function fetchAllPages(wrapper) {
  if (window.fetchAllPromise) {
    return window.fetchAllPromise;
  }
  if (window.fetchAllCompleted) {
    return;
  }

  const productList = document.querySelector('.product-list');
  if (!productList || !wrapper) {
    return;
  }

  window.fetchAllCompleted = true;

  window.fetchAllPromise = (async function() {
    const totalProducts = parseInt(wrapper.dataset.totalProducts, 10) || 0;
    let currentPage = parseInt(wrapper.dataset.ajaxPage, 10) || 1;
    const collectionUrl = wrapper.dataset.collectionUrl;
    const sectionId = wrapper.dataset.sectionId;
    const existingHandles = new Set(
      Array.from(productList.querySelectorAll('.product-card-wrapper[data-product-handle]'), function(card) {
        return card.getAttribute('data-product-handle');
      })
    );
    const shopifyPageSize = 250;
    const maxPages = 40;
    const totalPages = totalProducts > 0
      ? Math.min(maxPages, Math.ceil(totalProducts / shopifyPageSize))
      : maxPages;
    const pagesToFetch = [];

    for (let page = currentPage + 1; page <= totalPages; page += 1) {
      pagesToFetch.push(page);
    }

    if (pagesToFetch.length === 0) {
      return;
    }

    try {
      const htmlPages = await Promise.all(
        pagesToFetch.map(function(page) {
          return fetchCollectionPage(collectionUrl, sectionId, page).catch(function() {
            return '';
          });
        })
      );

      const frag = document.createDocumentFragment();
      let appended = 0;
      let lastFetchedPage = currentPage;

      htmlPages.forEach(function(html, index) {
        const products = collectPageProducts(html, existingHandles);
        if (!products.length) {
          return;
        }
        lastFetchedPage = pagesToFetch[index];
        products.forEach(function(product) {
          frag.appendChild(product);
          appended += 1;
        });
      });

      if (appended > 0) {
        window.isCollectionReordering = true;
        productList.appendChild(frag);
        wrapper.setAttribute('data-ajax-page', String(lastFetchedPage));
        if (typeof window.reassignCollectionBatches === 'function') {
          window.reassignCollectionBatches();
        }
      }
    } catch (error) {
      console.error('[LoadMore] fetchAllPages failed:', error);
      window.fetchAllCompleted = false;
    } finally {
      requestAnimationFrame(function() {
        window.isCollectionReordering = false;
      });
    }
  })();

  try {
    await window.fetchAllPromise;
  } finally {
    window.fetchAllPromise = null;
  }
}

window.fetchAllPages = fetchAllPages;

function startCollectionPrefetch() {
  const wrapper = document.querySelector('.load-more-wrapper');
  if (!wrapper) return;

  fetchAllPages(wrapper).then(function() {
    window.dispatchEvent(new CustomEvent('allProductsLoaded', {
      detail: { background: true }
    }));
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startCollectionPrefetch);
} else {
  startCollectionPrefetch();
}
